import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import Swal from "sweetalert2";
import "./Sms.css";
import Navbar from "../../shared/Navbar";

const Sms = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const {
    firstName,
    Name,
    AccountNo,
    AccountType,
    Recieved,
    PresentBalance,
    Phone,
    agentUserName
  } = location.state || {};

  const [mobileNumber, setMobileNumber] = useState(Phone || "");

  const msg = `Dear ${Name}, your Account type: ${AccountType}, A/C No: ${AccountNo} Credited Rs: ${Recieved} Successfully. Your Present Balance is Rs: ${PresentBalance}. Thank you ${firstName}`;
  const [bodySMS, setBodySMS] = useState(msg);

  useEffect(() => {
    setBodySMS(msg);
  }, [msg]);

  const goHome = () => {
    setMobileNumber("");
    navigate("/Home", { state: { firstName, agentUserName } });
  };

  const goCollect = () => {
    setMobileNumber("");
    navigate("/Collect", { state: { firstName, agentUserName } });
  };

  const gotoCollect = async () => {
    const result = await Swal.fire({
      title: 'Confirm Navigation',
      text: "Do you want to go to Collection Screen? Did you send SMS?",
      icon: 'question',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, go to Collection',
      cancelButtonText: 'Cancel'
    });
    
    if (result.isConfirmed) {
      goCollect();
    }
  };

  const gotoHome = async () => {
    const result = await Swal.fire({
      title: 'Confirm Navigation',
      text: "Do you want to go to Home Screen? Did you send SMS?",
      icon: 'question',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, go to Home',
      cancelButtonText: 'Cancel'
    });
    
    if (result.isConfirmed) {
      goHome();
    }
  };

  const initiateSMS = () => {
    if (mobileNumber.length !== 10) {
      Swal.fire({
        icon: 'error',
        title: 'Invalid Number',
        text: 'Please insert correct 10-digit contact number',
        confirmButtonColor: '#3085d6',
      });
      return;
    }

    // Encode the message for URL
    const encodedMsg = encodeURIComponent(bodySMS);

    // Construct the sms: URL
    const smsLink = `sms:${mobileNumber}?body=${encodedMsg}`;

    // Show confirmation before sending
    Swal.fire({
      title: 'Confirm SMS',
      text: `Send this message to ${mobileNumber}?`,
      icon: 'question',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, send it!',
      cancelButtonText: 'Cancel'
    }).then((result) => {
      if (result.isConfirmed) {
        // Open SMS app
        window.location.href = smsLink;
        
        // Show success message
        Swal.fire({
          icon: 'success',
          title: 'SMS Ready!',
          text: 'The SMS app should open with your message. If not, check your device settings.',
          confirmButtonColor: '#3085d6',
        });
      }
    });
  };

  return (
    <div>
      <Navbar />
    
    <div className="Sms-container">
      <div className="Sms-centerizedView">
        <div className="Sms-authBox">
          <h2 className="Sms-titleText">Sending SMS</h2>
          <div className="Sms-hr"></div>

          <div className="Sms-inputBox">
            <label className="Sms-inputLabel">Enter Mobile Number</label>
            <input
              value={mobileNumber}
              onChange={(e) => setMobileNumber(e.target.value)}
              placeholder="Enter Contact Number"
              type="number"
              className="Sms-input"
            />
          </div>

          <div className="Sms-inputBox">
            <label className="Sms-inputLabel">SMS Details</label>
            <textarea
              value={bodySMS}
              onChange={(e) => setBodySMS(e.target.value)}
              placeholder="Enter SMS body"
              className="Sms-bodyInput"
              rows="5"
              readOnly
            />
          </div>

          <div className="Sms-sendButtonWrapper">
            <button className="Sms-loginButton" onClick={initiateSMS}>
              Send Message
            </button>
          </div>


          <div className="Sms-btnRow">
            <button className="Sms-addButton" onClick={gotoHome}>
              Home
            </button>
            <button className="Sms-addButton" onClick={gotoCollect}>
              Collect
            </button>
          </div>
        </div>
      </div>
    </div>
    </div>
  );
};

export default Sms;